import { Component, Input, Optional } from '@angular/core';
import { LayoutComponent } from '@shared/layout/layout.component';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';

@Component({
  selector: 'mfp-scroll-button',
  templateUrl: './scroll-button.component.html',
  styleUrls: ['./scroll-button.component.scss']
})
export class ScrollButtonComponent {

  @Input() label = '';
  @Input() icon = 'assets/icons/arrow-down-white.svg';
  @Input() scrollElementId = '';
  @Input() scrollTopOffset = 0;
  @Input() takeHeadersIntoAccountOnScroll = true;
  @Input() disabled = false;

  private get scrollContainerEl(): HTMLElement {
    return this.layoutComponent?.scrollContainerDirective?.containerEl || (window as unknown as HTMLElement);
  }

  private get lifePlanHeaderEl(): HTMLElement | null {
    return document.getElementById('lifePlanHeader');
  }

  constructor(@Optional() private layoutComponent: LayoutComponent) { }

  scroll(): void {
    const element = document.getElementById(this.scrollElementId);
    if (!element) {
      return;
    }

    const lifePlanHeader = this.lifePlanHeaderEl;
    let lifePlanHeaderOffset = 0;
    if (lifePlanHeader) {
      // Apply more offset due to the health indicator
      lifePlanHeaderOffset = lifePlanHeader.getBoundingClientRect().height + 64;
    }

    this.scrollContainerEl.scrollTo({
      top: this.getTopOffset(element, lifePlanHeaderOffset),
      behavior: 'smooth'
    });
    fromEvent(this.scrollContainerEl, 'scroll')
      .pipe(
        debounceTime(100),
        take(1)
      )
      .subscribe({
        next: () => element.focus()
      });
  }

  private getTopOffset(controlEl: HTMLElement, offset: number): number {
    const controlElTop = controlEl.getBoundingClientRect().top;

    if (this.layoutComponent) {
      const containerTop = this.scrollContainerEl.getBoundingClientRect().top;
      const absoluteControlElTop = controlElTop + this.scrollContainerEl.scrollTop;
      return absoluteControlElTop - containerTop - offset;
    } else {
      const absoluteControlElTop = controlElTop + window.scrollY;
      return absoluteControlElTop - offset;
    }
  }
}
